import SubcategoryPage from '@/components/template/SubcategoryPage';

const Freestanding = () => {
  const products = [
    {
      title: "Freestanding Model 1",
      imageSrc: "https://images.unsplash.com/photo-1618220924273-338d82d6b886?auto=format&fit=crop&q=80",
      url: "/ogledala/freestanding/model-1"
    },
    {
      title: "Freestanding Model 2",
      imageSrc: "https://images.unsplash.com/photo-1493552152660-f915ab47ae9d?auto=format&fit=crop&q=80",
      url: "/ogledala/freestanding/model-2"
    },
    {
      title: "Freestanding Model 3",
      imageSrc: "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?auto=format&fit=crop&q=80",
      url: "/ogledala/freestanding/model-3"
    },
    {
      title: "Freestanding Model 4",
      imageSrc: "https://images.unsplash.com/photo-1552454799-ca5cfdc612c8?auto=format&fit=crop&q=80",
      url: "/ogledala/freestanding/model-4"
    }
  ];

  return (
    <SubcategoryPage
      title="Freestanding Theater"
      description="Elegantna prostostoječa ogledala za ustvarjanje dramatičnega učinka v vašem prostoru. Popolna kombinacija funkcionalnosti in umetniškega izraza."
      heroImage="https://images.unsplash.com/photo-1618220924273-338d82d6b886?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default Freestanding;